/* __next_internal_client_entry_do_not_use__ EventsThemeShape auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Arch } from "@faire/web--source/slate/icons/faire-markets/Arch";
import { HalfMoon } from "@faire/web--source/slate/icons/faire-markets/HalfMoon";
import { Primary } from "@faire/web--source/slate/icons/faire-markets/market-january-2024/Primary";
import { Secondary } from "@faire/web--source/slate/icons/faire-markets/market-january-2024/Secondary";
import { Tertiary } from "@faire/web--source/slate/icons/faire-markets/market-january-2024/Tertiary";
import { Primary as PrimaryFsm23 } from "@faire/web--source/slate/icons/faire-markets/market-july-2023/Primary";
import { Secondary as SecondaryFsm23 } from "@faire/web--source/slate/icons/faire-markets/market-july-2023/Secondary";
import { Tertiary as TertiaryFsm23 } from "@faire/web--source/slate/icons/faire-markets/market-july-2023/Tertiary";
import { Snowflake as SnowflakeFwm23 } from "@faire/web--source/slate/icons/faire-markets/Snowflake";
import { Sun } from "@faire/web--source/slate/icons/faire-markets/Sun";
import { Tidepool } from "@faire/web--source/slate/icons/faire-markets/Tidepool";
import { Primary as PrimaryFwm23 } from "@faire/web--source/slate/icons/faire-markets/winter-market-2023/Primary";
import { Secondary as SecondaryFwm23 } from "@faire/web--source/slate/icons/faire-markets/winter-market-2023/Secondary";
import { Tertiary as TertiaryFwm23 } from "@faire/web--source/slate/icons/faire-markets/winter-market-2023/Tertiary";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { withAutoDimension } from "@faire/web--source/slate/Theme/withAutoDimension";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
import React from "react";
var BadgeShapeBase = function(props) {
    var _props_color;
    var color = (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : eventsThemeColors.faireMarket.badgeIcon;
    return /*#__PURE__*/ _jsx(Sun, _object_spread_props(_object_spread({}, props), {
        color: color
    }));
};
var BadgeShapeBaseFsm23 = function(props) {
    var _props_color;
    var color = (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : eventsThemeColors[PromotionalEventType.FAIRE_MARKET_JULY_2023].badgeIcon;
    return /*#__PURE__*/ _jsx(Sun, _object_spread_props(_object_spread({}, props), {
        color: color
    }));
};
var BadgeShapeBaseFwm23 = function(props) {
    return /*#__PURE__*/ _jsx(SnowflakeFwm23, _object_spread({}, props));
};
var BadgeShapeBaseFsm22 = function(props) {
    var _props_color;
    var color = (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : eventsThemeColors[PromotionalEventType.FAIRE_SUMMER_MARKET_2022].badgeIcon;
    return /*#__PURE__*/ _jsx(Sun, _object_spread_props(_object_spread({}, props), {
        color: color
    }));
};
var BadgeShape = withAutoDimension(BadgeShapeBase);
var BadgeShapeFsm23 = withAutoDimension(BadgeShapeBaseFsm23);
var BadgeShapeFwm23 = withAutoDimension(BadgeShapeBaseFwm23);
var BadgeShapeFsm22 = withAutoDimension(BadgeShapeBaseFsm22);
var PrimaryShapeBase = function(props) {
    return /*#__PURE__*/ _jsx(Primary, _object_spread({}, props));
};
var PrimaryShapeBaseFsm23 = function(props) {
    return /*#__PURE__*/ _jsx(PrimaryFsm23, _object_spread({}, props));
};
var PrimaryShapeBaseFwm23 = function(props) {
    return /*#__PURE__*/ _jsx(PrimaryFwm23, _object_spread({}, props));
};
var PrimaryShapeBaseFsm22 = function(props) {
    return /*#__PURE__*/ _jsx(Arch, _object_spread({}, props));
};
var PrimaryShape = withAutoDimension(PrimaryShapeBase);
var PrimaryShapeFsm23 = withAutoDimension(PrimaryShapeBaseFsm23);
var PrimaryShapeFwm23 = withAutoDimension(PrimaryShapeBaseFwm23);
var PrimaryShapeFsm22 = withAutoDimension(PrimaryShapeBaseFsm22);
var SecondaryShapeBase = function(props) {
    return /*#__PURE__*/ _jsx(Secondary, _object_spread({}, props));
};
var SecondaryShapeBaseFsm23 = function(props) {
    return /*#__PURE__*/ _jsx(SecondaryFsm23, _object_spread({}, props));
};
var SecondaryShapeBaseFwm23 = function(props) {
    return /*#__PURE__*/ _jsx(SecondaryFwm23, _object_spread({}, props));
};
var SecondShapeBaseFsm22 = function(props) {
    return /*#__PURE__*/ _jsx(HalfMoon, _object_spread({}, props));
};
var SecondaryShape = withAutoDimension(SecondaryShapeBase);
var SecondaryShapeFsm23 = withAutoDimension(SecondaryShapeBaseFsm23);
var SecondaryShapeFwm23 = withAutoDimension(SecondaryShapeBaseFwm23);
var SecondaryShapeFsm22 = withAutoDimension(SecondShapeBaseFsm22);
var TertiaryShapeBase = function(props) {
    return /*#__PURE__*/ _jsx(Tertiary, _object_spread({}, props));
};
var TertiaryShapeBaseFsm23 = function(props) {
    return /*#__PURE__*/ _jsx(TertiaryFsm23, _object_spread({}, props));
};
var TertiaryShapeBaseFwm23 = function(props) {
    return /*#__PURE__*/ _jsx(TertiaryFwm23, _object_spread({}, props));
};
var TertiaryShapeBaseFsm22 = function(props) {
    return /*#__PURE__*/ _jsx(Tidepool, _object_spread({}, props));
};
var TertiaryShape = withAutoDimension(TertiaryShapeBase);
var TertiaryShapeFsm23 = withAutoDimension(TertiaryShapeBaseFsm23);
var TertiaryShapeFwm23 = withAutoDimension(TertiaryShapeBaseFwm23);
var TertiaryShapeFsm22 = withAutoDimension(TertiaryShapeBaseFsm22);
export var EventsThemeShape = {
    faireMarket: {
        badge: BadgeShape,
        primary: PrimaryShape,
        secondary: SecondaryShape,
        tertiary: TertiaryShape
    },
    FAIRE_MARKET_JULY_2023: {
        badge: BadgeShapeFsm23,
        primary: PrimaryShapeFsm23,
        secondary: SecondaryShapeFsm23,
        tertiary: TertiaryShapeFsm23
    },
    FAIRE_WINTER_MARKET_2023: {
        badge: BadgeShapeFwm23,
        primary: PrimaryShapeFwm23,
        secondary: SecondaryShapeFwm23,
        tertiary: TertiaryShapeFwm23
    },
    FAIRE_SUMMER_MARKET_2022: {
        badge: BadgeShapeFsm22,
        primary: PrimaryShapeFsm22,
        secondary: SecondaryShapeFsm22,
        tertiary: TertiaryShapeFsm22
    }
};
